module.exports = {
      id: "simple-arrow-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#simple-arrow",
      toString: function () {
        return this.url;
      }
    }